import React from "react";
import Visibility from "../utils/Visibility";
import { AddToCart, CalcQuantity } from "../utils/CartFunctions";
import { Button } from "../ui/button";
import Spacer from "../Spacer";
import { Skeleton } from "../ui/skeleton";
import { SheetClose } from "../ui/sheet";
import { toast } from "react-toastify";
import ProductModel from "../../Models/PorductModel";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";

export function ProductTags({ product, t }: { product: ProductModel; t: any }) {
  const tagClass = `text-sm px-2 py-1 bg-primary text-onPrimary rounded-md `;

  return (
    <Visibility visible={product.new || product.unavailable || product.common}>
      <div className="flex gap-1 flex-wrap">
        <Visibility visible={product.new}>
          <p className={tagClass}>{t("gloabl.new")}</p>
        </Visibility>
        <Visibility visible={product.common}>
          <p className={tagClass}>{t("gloabl.common")}</p>
        </Visibility>
        <Visibility visible={product.unavailable}>
          <p className={tagClass}>{t("gloabl.unavailable")}</p>
        </Visibility>
      </div>
    </Visibility>
  );
}

export function ProductCartElement({
  product,
  t,
  navigate,
  params,
  optionsSelected,
  itemLoading,
  productSheet,
}: {
  product: ProductModel;
  t: any;
  navigate: any;
  params: any;
  optionsSelected: any;
  itemLoading: any;
  productSheet: any;
}) {
  const activeOrder = Number(
    localStorage.getItem(`active_order${params.branch_id}`)
  );

  const [quantity, setQuantity] = React.useState(1);
  const [note, setNote] = React.useState("");
  const buttonQuantityClass = `bg-primary text-onPrimary px-4 py-2 rounded-lg text-lg`;

  return (
    <Visibility visible={activeOrder === 1}>
      <Visibility visible={!itemLoading}>
        <div className="flex flex-col gap-2">
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <h2 className="text-lg font-semibold">{t("gloabl.quantity")}</h2>
              <div className="flex items-center gap-4">
                <Button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  className={buttonQuantityClass}
                >
                  
                  -
                </Button>
                <span className="text-base">{quantity}</span>
                <Button
                  onClick={() => setQuantity((q) => q + 1)}
                  className={buttonQuantityClass}
                >
                  +
                </Button>
              </div>
            </div>
          </div>
          <textarea
            className="w-full border-2 border-gray-300 rounded-md p-2"
            placeholder={t("gloabl.addNote")}
            name="note"
            onChange={(e) => setNote(e.target.value)}
          ></textarea>
          <Spacer height={4} />
          <Visibility visible={productSheet}>
            <SheetClose asChild>
              <Button
                onClick={() => {
                  AddToCart({
                    element: {
                      ...product,
                      option: optionsSelected,
                      note: note,
                    },
                    params: params,
                    navigate: navigate,
                    t: t,
                    quantity: quantity,
                    // handleAddedToCartNotice: handleAddedToCart(),
                  });
                  CalcQuantity(params.branch_id);
                  toast(t("gloabl.addedToCart"), {
                    bodyClassName: "rounded-lg",
                    className: "bg-green-500 text-white rounded-lg shadow-lg",
                    progressClassName: "bg-white text-green-500",
                    hideProgressBar: true,
                    onClick: () => {
                      navigate(`/${params.domain}/${params.branch_id}/cart`);
                    },
                  });
                }}
                className="text-onPrimary bg-primary rounded-xl hover:bg-primary/90 focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium text-sm px-5 py-2.5 text-center"
              >
                {t("gloabl.AddToCart")}
              </Button>
            </SheetClose>
          </Visibility>

          <Visibility visible={!productSheet}>
            <Button
              onClick={() => {
                AddToCart({
                  element: { ...product, option: optionsSelected, note: note },
                  params: params,
                  navigate: navigate,
                  t: t,
                  quantity: quantity,
                  // handleAddedToCartNotice: handleAddedToCart(),
                });
                toast(t("gloabl.addedToCart"), {
                  bodyClassName: "rounded-lg",
                  className: "bg-green-500 text-white rounded-lg shadow-lg",
                  progressClassName: "bg-white text-green-500",
                  hideProgressBar: true,
                  onClick: () => {
                    navigate(`/${params.domain}/${params.branch_id}/cart`);
                  },
                });
                CalcQuantity(params.branch_id);
              }}
              className="text-onPrimary bg-primary rounded-xl hover:bg-primary/90 focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium text-sm px-5 py-2.5 text-center"
            >
              {t("gloabl.AddToCart")}
            </Button>
          </Visibility>
        </div>
      </Visibility>
      <Visibility visible={itemLoading}>
        <RenderLoadingCartElemnt />
      </Visibility>
    </Visibility>
  );
}

const RenderLoadingCartElemnt = () => {
  return (
    <div className="flex flex-col gap-2 px-5">
      <div className="space-y-2 flex justify-between items-center   ">
        <Skeleton className={"w-20 h-7"} />
        <div className="flex items-center gap-4">
          <Skeleton className={"w-9 h-9"} />
          <Skeleton className={"w-7 h-7"} />
          <Skeleton className={"w-9 h-9"} />
        </div>
      </div>
      <Skeleton className={"w-full h-20 rounded-md p-2"} />
      <Spacer height={4} />
      <Skeleton className={"w-full h-9"} />
    </div>
  );
};
export const ProductDetails = ({
  product,
  name,
  description,
}: {
  product: any;
  name: string;
  description: string;
}) => {
  const formattedDescription = product[description]?.replace(/\n/g, "<br/>");
  return (
    <>
      <p
        className=" text-[0.9rem] font-semibold line-clamp-3"
        dangerouslySetInnerHTML={{ __html: formattedDescription }}
      ></p>
      <div className="text-base font-semibold flex justify-end gap-[65%]">
        <p
          className={`price flex items-center gap-1 ${
            product.price_offer
              ? "line-through decoration-primary decoration-solid decoration-2"
              : ""
          }`}
        >
          <UAEDirhamIcon className="w-4 h-4 " />
          {product.price}
        </p>
        <Visibility visible={product.price_offer}>
          <p className="price-offer flex items-center gap-1 font-bold">
            <UAEDirhamIcon className="w-4 h-4 " />
            {product.price_offer}
          </p>
        </Visibility>
      </div>
    </>
  );
};
